<template>
  <div>
    <v-select v-model="profissao"
              label="descricao"
              placeholder="Digite para buscar"
              class="form-control form-control-sm"
              :options="profissoes"
              :disabled="disabled"
              @search="searchProfissao"
              @input="changeProfissao"
              @open="searchProfissao(preLoad)">
      <template slot="option"
                slot-scope="option">
        <div class="d-center">
          {{ option.descricao }}
        </div>
      </template>
      <template slot="selected-option"
                slot-scope="option">
        <div class="selected d-center">
          {{ option.descricao }}
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
  /* constants */
  const PROFISSOES_DEFAULT =  [{ descricao: 'Outras', codigo: -2 }, { descricao: 'Sem profissão remunerada', codigo: -1 }]

  /* services */
  import ProfissoesService from "@/services/Registros/ProfissoesService"

  export default {
    name: 'ProfissoesCBO',
    props: {
      ocupacao: { type: [Array, Object], default: () => {} },
      preLoad: { type: String, default: () => '' },
      disabled: { type: Boolean, default: false },
      propOrdem: { type: Number, default: 0}
    },
    data () {
      return {
        profissao: this.ocupacao || {},
        selectProfissoesIsLoading: false,
        profissoes: PROFISSOES_DEFAULT
      }
    },
    watch: {
      ocupacao () {
        this.profissao = this.ocupacao
      },
      preLoad () {
        this.searchProfissao(this.preLoad)
      },
      propOrdem () {
        if (!this.ocupacao) {
          this.profissao = {}
        }
      },
      disabled (val) {
        let container = this.$el
        let tags = container.querySelectorAll(".multiselect__single")

        if (tags) {
          for (const tag of tags) {
            tag.style["background-color"] = (val) ? "rgb(223, 224, 225)" : "#fff"
          }
        }
      }
    },
    methods: {
      limitText (count) { return `e ${count} outras profissões` },
      searchProfissao (busca) {
        if (!busca) { return }
        ProfissoesService.searchProfissaoByName(busca)
          .then(response => {
            //Remove itens ja presentes no PROFISSOES_DEFAULT
            const index = response.findIndex(profissao => profissao.codigo == -1 || profissao.codigo == -2)
            if (index != -1) response.splice(index, 1)

            this.profissoes = PROFISSOES_DEFAULT.concat(response)

            //Limita a quantidade de itens no array em 150
            this.profissoes = this.profissoes.filter((profissao, index) => index < 450)
          })
      },
      changeProfissao () {
        this.profissoes =  PROFISSOES_DEFAULT || {}
        let profissao = this.profissao || { codigo: 0 }

        this.$emit('changed', profissao)
        this.$emit('input', profissao.codigo)
      }
    }
  }
</script>
